import React, { useState, useEffect } from 'react';

import BarLineGraph from 'components/SocialSurvey/SocialEconomicData/BarLineGraph';
import FishesSelect from 'components/SocialSurvey/SocialEconomicData/FishesSelect';
import FishesLineGraph from 'components/SocialSurvey/SocialEconomicData/FishesLineGraph';

import ScaleComparasionContent from './ScaleComparasionContent';
import { BE_URL } from 'utils/config';

function VillageEconomyAndIndustryContent() {
  const [active, setActive] = useState({
    fish: '文蛤',
    year: '2024',
  });
  const [fishesData, setFishesData] = useState({});
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const isNoActiveFish = active.fish === '';

  const normalizeFishRows = (rows) =>
    (rows || []).map((r) => ({
      ...r,
      養殖面積: r['養殖面積（公頃）'],
      在池: r['在池-放養量（尾、粒、隻）'],
      新放養: r['新放養-放養量（尾、粒、隻）'],
    }));

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`${BE_URL}/api/fishery-stats/`);
        if (!res.ok) throw new Error('Network response was not ok');
        const json = await res.json();

        const mapped = {
          文蛤: normalizeFishRows(json.villageClamsData),
          烏魚: normalizeFishRows(json.villageMulletData),
          虱目魚: normalizeFishRows(json.villageMilkfishData),
          蜆: normalizeFishRows(json.villageClamData),
          白蝦: normalizeFishRows(json.villageWhiteShrimpData),
          吳郭魚: normalizeFishRows(json.villageTilapiaData),
          鰻魚: normalizeFishRows(json.villageEelData),
          日本黑蜆: normalizeFishRows(json.villageYamatoClamData),
          西施貝: normalizeFishRows(json.villagePurpleClamData),
        };

        setFishesData(mapped);

        // 如果預設年份不在資料中，改成該物種的第一筆年份
        const rowsForActive = mapped[active.fish] || [];
        if (rowsForActive.length > 0) {
          const firstYear = String(rowsForActive[0][active.fish]);
          setActive((prev) => ({ ...prev, year: firstYear }));
        }
      } catch (error) {
        console.error('載入 FisheryStats 失敗:', error);
        setErr(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const hasFishData =
    !loading &&
    !err &&
    fishesData &&
    active.fish &&
    Array.isArray(fishesData[active.fish]) &&
    fishesData[active.fish].length > 0;

  return (
    <>
      <div className="mb-3 text-end text-muted">
        資料來源： 農業部漁業署養殖漁業放養查詢平臺
      </div>

      <section className="u-section">
        <div className="l-social-economy-data__section">
          <h4 className="l-social-economy-data__subtitle">牡蠣放養統計</h4>
          <BarLineGraph />
          <ScaleComparasionContent active={active} setActive={setActive} />
        </div>
      </section>

      <section className="u-section">
        <div className="l-social-economy-data__section">
          <h4 className="l-social-economy-data__subtitle">
            芳苑鄉養殖漁業放養量
          </h4>

          <FishesSelect
            active={active}
            setActive={setActive}
            rawData={fishesData}
          />

          {loading && <p>資料載入中...</p>}
          {!loading && !err && isNoActiveFish && <p>請先選擇物種</p>}

          {!loading && !err && !isNoActiveFish && hasFishData && (
            <>
              {[
                {
                  id: '1',
                  title: '養殖戶數',
                  cols: ['魚苗戶', '養殖戶'],
                  unit: '',
                },
                {
                  id: '2',
                  title: '養殖面積',
                  cols: ['養殖面積'],
                  unit: '公頃',
                },
                {
                  id: '3',
                  title: '放養量',
                  cols: ['在池', '新放養'],
                  unit: '尾、粒、隻',
                },
              ].map((item) => (
                <FishesLineGraph
                  key={item.id}
                  active={active}
                  allData={fishesData}
                  item={item}
                />
              ))}
            </>
          )}

          {!loading && !err && !hasFishData && <p>目前沒有資料可顯示</p>}
        </div>
      </section>
    </>
  );
}

export default VillageEconomyAndIndustryContent;
